<script setup lang="ts">

import { computed, ref, watch } from 'vue';

type Props =
{
    title?: string,
    options: {value:any, title:string}[],
    variant?: 'button' | 'option',
    multiple?: boolean
}

const model = defineModel<any|any[]|undefined>( { required: true } );
const emit = defineEmits( [ 'update:modelValue' ] );
const multiValue = ref<any[]>( [] );

const { title, options, variant = 'option', multiple = false } = defineProps<Props>();
const hasTitle = computed( () => ( title ?? '' ).length > 0 );

watch( model, v => multiValue.value = v ?? [] );

function toggle( option: any )
{

    if( multiple !== true )
    {
        model.value = option;
        return;
    }

    if( multiValue.value.find( i => i == option ) != null )
    {
        multiValue.value = multiValue.value.filter( v => v != option );
    }

    else
    {
        multiValue.value.push( option );
    }

    emit( 'update:modelValue', multiValue.value ); 

}

</script>

<template>

        <div class="flex gap-3 min-h-[4rem] items-start">

            <div v-if="hasTitle"
                class="basis-1/4 min-h-[4rem] flex items-center font-semibold text-lg tracking-wider gap-3 uppercase">
                {{ title }}
                <div class="flex-1 h-0.5 bg-white/20"></div>
            </div>
            
            <div>
                <div class="flex items-stretch justify-start gap-3 grow flex-wrap"
                    :class="hasTitle ? 'basis-3/4' : 'basis-full'">
                    <TouchButton 
                        v-for="option in options"
                        :selected="multiple === true ? multiValue.some( v => v == option.value ) : option.value == model"
                        :variant="variant"
                        @click="() => toggle( option.value )"
                        v-html="option.title"
                    />
                </div>
                <div v-if="multiple === true" 
                    class="text-white/60 text-sm mt-2">
                        (Choose one or more)
                </div>
            </div>

        </div>

</template>